export const BACKDROP_OPTIONS = [
  {
    id: "pink",
    label: "nudio Pink",
    description: "signature nudio pink seamless",
    hex: "#f6cadc",
  },
  {
    id: "fashion-grey",
    label: "City Fog",
    description: "light grey seamless",
    hex: "#b7bcc4",
  },
  {
    id: "deep-yellow",
    label: "Amber Yellow",
    description: "glowing amber seamless",
    hex: "#f5a623",
  },
  {
    id: "bone",
    label: "Bone",
    description: "cream/off-white seamless",
    hex: "#e8dcc9",
  },
  {
    id: "blue-mist",
    label: "Powder Blue",
    description: "airy powder blue seamless",
    hex: "#7cade3",
  },
];
